import React from 'react';

const SvgAo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="AO_svg__b">
        <stop stopColor="#FF323E" offset="0%" />
        <stop stopColor="#FD0D1B" offset="100%" />
      </linearGradient>
      <path id="AO_svg__e" d="M0 10.667h28V20H0z" />
      <filter
        x="-5.4%"
        y="-16.1%"
        width="110.7%"
        height="132.1%"
        filterUnits="objectBoundingBox"
        id="AO_svg__d"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="AO_svg__g" d="M0 0h28v10.667H0z" />
      <filter
        x="-5.4%"
        y="-14.1%"
        width="110.7%"
        height="128.1%"
        filterUnits="objectBoundingBox"
        id="AO_svg__f"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path
        d="M14.174 11.806l-1.877-1.251a.667.667 0 0 1 .74-1.11l2.047 1.365a2.667 2.667 0 0 0-1.67-3.818.667.667 0 1 1 .345-1.287 4 4 0 0 1 2.439 5.848l.838.559a.667.667 0 1 1-.74 1.11l-.949-.634a3.996 3.996 0 0 1-3.659.844.667.667 0 1 1 .345-1.288 2.66 2.66 0 0 0 2.141-.338zm-1.507-3.14a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.334z"
        id="AO_svg__i"
      />
      <filter
        x="-8.1%"
        y="-6.3%"
        width="116.3%"
        height="125.4%"
        filterUnits="objectBoundingBox"
        id="AO_svg__h"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AO_svg__c" fill="#fff">
        <use xlinkHref="#AO_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AO_svg__a" />
      <path fill="url(#AO_svg__b)" mask="url(#AO_svg__c)" d="M0 0h28v20H0z" />
      <g mask="url(#AO_svg__c)">
        <use fill="#000" filter="url(#AO_svg__d)" xlinkHref="#AO_svg__e" />
        <use fill="#262626" xlinkHref="#AO_svg__e" />
      </g>
      <g mask="url(#AO_svg__c)">
        <use fill="#000" filter="url(#AO_svg__f)" xlinkHref="#AO_svg__g" />
        <use fill="#DD2137" xlinkHref="#AO_svg__g" />
      </g>
      <g fillRule="nonzero" mask="url(#AO_svg__c)">
        <use fill="#000" filter="url(#AO_svg__h)" xlinkHref="#AO_svg__i" />
        <use fill="#F8D84B" xlinkHref="#AO_svg__i" />
      </g>
    </g>
  </svg>
);

export default SvgAo;
